import { render, staticRenderFns } from "./InvoicingModalityTable.vue?vue&type=template&id=0989cfa8"
import script from "./InvoicingModalityTable.vue?vue&type=script&lang=js"
export * from "./InvoicingModalityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports